// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.notify-test.stage.monatest.icu/auto-open-api-spec.yaml 1.8.25
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2025-07-29T19:00:31.318773+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { NotificationListResponse } from './notificationListResponse';
import { Notification } from './notification';

export interface PaginatedNotificationListResponseList {
    next?: string | null;
    previous?: string | null;
    results?: Array<NotificationListResponse>;
    unread_count: number;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PaginatedNotificationListResponseList
 */
export namespace PaginatedNotificationListResponseList {
    /**
     * PaginatedNotificationListResponseList Frontend Model with camelCase properties
     * @since 2025-07-29T19:00:31.318773+03:00[Europe/Kiev]
     * @version 1.8.25
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        next?: string | null;
        previous?: string | null;
        unreadCount: number;
        @Type(() => Notification.Model) results?: Array<Notification.Model>;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PaginatedNotificationListResponseList DTO
     * Transforms PaginatedNotificationListResponseList model from/to API object
     * @since 2025-07-29T19:00:31.318773+03:00[Europe/Kiev]
     * @version 1.8.25
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PaginatedNotificationListResponseList model */
        static toModel(obj: PaginatedNotificationListResponseList): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PaginatedNotificationListResponseList model */
        static toApi(obj: Model): PaginatedNotificationListResponseList {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PaginatedNotificationListResponseList;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
